import { AppSidebar } from "@/components/app-sidebar"
import { SidebarProvider, SidebarInset, SidebarTrigger } from "@/components/ui/sidebar"
import { SearchBar } from "@/components/search-bar"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import LightRays from "@/components/light-rays"

export const Route = createFileRoute("/_app")({
  component: AppLayout,
})

function AppLayout() {
  return (
    <>
      <div
        className="fixed inset-0 pointer-events-none z-50"
        style={{ mixBlendMode: "screen", opacity: 0.5 }}
      >
        <LightRays
          raysOrigin="top-right"
          raysColor="#ffffff"
          raysSpeed={0.5}
          lightSpread={2}
          rayLength={6}
          fadeDistance={1}
          followMouse={true}
          mouseInfluence={0.05}
          pulsating={false}
          noiseAmount={0.1}
        />
      </div>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <header className="flex h-16 shrink-0 items-center gap-3 border-b bg-background/90 supports-backdrop-filter:bg-background/80 backdrop-blur-sm px-4 sticky top-0 z-20">
            <SidebarTrigger className="shrink-0" />
            <div className="flex flex-1 justify-center min-w-0">
              <SearchBar />
            </div>
          </header>
          <main
            style={{ viewTransitionName: "page-content" }}
            className="flex-1 overflow-hidden flex flex-col relative z-0"
          >
            <Outlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
    </>
  )
}
